module.exports = __webpack_public_path__ + "media/images/icons/filled/property-safety-78e15a87734a1be4c5f37ec54677adc1.svg";